import { render, staticRenderFns } from "./Etapa.vue?vue&type=template&id=d5a8f95c"
import script from "./Etapa.vue?vue&type=script&lang=js"
export * from "./Etapa.vue?vue&type=script&lang=js"
import style0 from "./Etapa.vue?vue&type=style&index=0&id=d5a8f95c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports